import React from "react";

const urlRegex =
  /\bhttps?:\/\/[^\s/$.?#].[^\s]*/gi;

export default function Linkify({ text }) {
  if (!text || typeof text !== "string") return <>{text}</>;

  // Split text into parts where URLs are separate tokens
  const parts = text.split(urlRegex);

  // Extract the URLs themselves (match gives us all URLs)
  const urls = text.match(urlRegex) || [];

  const out = [];

  // Interleave text parts and URLs
  parts.forEach((part, i) => {
    out.push(<React.Fragment key={`text-${i}`}>{part}</React.Fragment>);

    if (urls[i]) {
      out.push(
        <a
          key={`url-${i}`}
          href={urls[i]}
          target="_blank"
          rel="noopener noreferrer"
        >
          {urls[i]}
        </a>
      );
    }
  });

  return <>{out}</>;
}
